import React from 'react';

import {connect} from 'react-redux';
import {Tree, treeBuild} from './Tree';
import * as apiActions from '../actions/apiEndCategorisActions';


class EndCategories extends Tree {

    constructor(props){
        super(props);

        this.addChild = this.addChild.bind(this);
        this.removeNode = this.removeNode.bind(this);

    }

    addChild(e){
        e.preventDefault();
        let parent_id = e.currentTarget.dataset.parent;
        let title = prompt('Имя новой категории');
        if(title){
            this.props.dispatch(apiActions.add(title, parent_id));
        }
    }
    removeNode(e){
    	if(confirm('Вы уверены что хотите удалить категорию?')){
    		let id = e.currentTarget.dataset.id;
			this.props.dispatch(apiActions.remove(id));
	    }
    }

	renderTitle(node){
    	return (
		    <span className="tree-node-title">
			    <span>{node.title}</span>
			      <a   className="glyphicon glyphicon-plus" aria-hidden="true" onClick={this.addChild} data-parent={node.id}>
			      </a>
		        <a  className="glyphicon glyphicon-remove" onClick={this.removeNode} data-id={node.id}>
		        </a>
		    </span>
	    );
	}


}

const EndCategoriesTreeBuilder = (store) => {
	return treeBuild(store.tree.tree);
};


const ConnectEndCategories = connect(EndCategoriesTreeBuilder)(EndCategories);
export default ConnectEndCategories;




// WEBPACK FOOTER //
// ./frontend/components/EndCategories.js